var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconGame = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-61.757 -431.419)" },
                React.createElement("path", { d: "M81.5,438.1c-1,0-3,1.5-4.7,1.5c-1.7,0-3.8-1.5-4.7-1.5c-6.2,0-9.8,16.7-5.1,16.7\n\t\tc3.9,0,4.4-4.9,9.8-4.9c4.3,0,6.9,4.8,9.8,4.8C91.2,454.7,87.7,438.1,81.5,438.1z" }),
                React.createElement("g", { transform: "translate(67.287 440.162)" },
                    React.createElement("path", { d: "M17.3,6.7c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2s0.5-1.2,1.2-1.2l0,0\n\t\t\tC16.8,5.6,17.3,6.1,17.3,6.7C17.3,6.7,17.3,6.7,17.3,6.7z" }),
                    React.createElement("path", { d: "M4.3,6.7c0,0.6-0.5,1.2-1.2,1.2S2,7.4,2,6.7s0.5-1.2,1.2-1.2S4.3,6.1,4.3,6.7L4.3,6.7z" }))))));
});
export default IconGame;
//# sourceMappingURL=IconGame.js.map